import React, { useState, useEffect} from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, apiRequest, apiMapRequest } from './authConfig';
import { getAccessToken } from './useAccessToken';
import { getRuntimeConfig } from '../runtime-config';
import { InteractionStatus } from '@azure/msal-browser';
//import { appInsights } from '../MSAppInsights/AppInsights';

const config = getRuntimeConfig();

function LoginPage() {
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      instance.loginRedirect(loginRequest);
    }
  }, [instance, inProgress]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div>Redirecting to login...</div>
    </div>
  );
  
}

export default LoginPage;